import { createFileRoute } from "@tanstack/react-router";

import { usageSessionsSearchSchema } from "@/features/usage/lib/usage-sessions-search";

export const Route = createFileRoute("/_protected/organization/$orgId/review")({
  validateSearch: usageSessionsSearchSchema,
});
